export { SearchPage } from './src/ui/search-page';
